import { render, staticRenderFns } from "./SafeWarning.vue?vue&type=template&id=26426a4e&"
import script from "./SafeWarning.vue?vue&type=script&lang=js&"
export * from "./SafeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports